import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatTooltip } from '@angular/material/tooltip'
import {
  ElderDataToolbarComponent,
  ElderQuantityPipe,
  ElderTableComponent,
  ElderTableToolbarDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProductSalesQuantityPipe } from '../../../features/pipes/product-sales-quantity.pipe'
import { Package } from '../package'

@Component({
  selector: 'app-packaging-goods',
  templateUrl: './packaging-goods.component.html',
  imports: [
    MatIcon,
    FormsModule,
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatTooltip,
    ElderTranslatePipe,
    ElderQuantityPipe,
    ProductSalesQuantityPipe,
  ],
})
export class PackagingGoodsComponent {
  pkg = input.required<Package>()
}
